// These are % percentages
export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 100]
